// Central color tokens for reusable styling across components

export const NIGHT_MODE_RED = '#d61e11';

// Add more tokens as needed, e.g.:
// export const BRAND_PRIMARY = '#...';
// export const TEXT_ON_DARK = '#...';


